// extracted by mini-css-extract-plugin
export var content = "ModalDownloadPresentation-module--content--FVjdZ";
export var icon = "ModalDownloadPresentation-module--icon--ILj1+";
export var items = "ModalDownloadPresentation-module--items--+jG8h";
export var item = "ModalDownloadPresentation-module--item--tdb3q";
export var image = "ModalDownloadPresentation-module--image--fuRDK";
export var download = "ModalDownloadPresentation-module--download--zM8++";
export var download_title = "ModalDownloadPresentation-module--download_title--wroeF";